import { Card, Fade, Icon, Modal, Slide } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import PropTypes from "prop-types";
import { getUproColor } from "utils/colors";

export default function ModalBienvenida({ open, handleClose }) {
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
    >
      <Fade in={open}>
        <Card
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            maxHeight: "90%",
            width: { xs: "80%", sm: "35%", xxl: "25%" },
            overflowY: "auto",
          }}
        >
          <Slide in={open} direction="up" mountOnEnter unmountOnExit>
            <Card>
              <SoftBox
                bgColor={getUproColor("uproGreen")}
                p={3}
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                textAlign="center"
              >
                <Icon
                  fontSize="large"
                  sx={{
                    color: "#fff",
                    animation: "shakes 1s",
                    "@keyframes shakes": {
                      "0%": {
                        transform: "rotate(0deg)",
                      },
                      "25%": {
                        transform: "rotate(10deg)",
                      },
                      "50%": {
                        transform: "rotate(-20deg)",
                      },
                      "75%": {
                        transform: "rotate(15deg)",
                      },
                      "100%": {
                        transform: "rotate(-5deg)",
                      },
                    },
                  }}
                >
                  check_circle
                </Icon>
                <SoftTypography variant="h5" color="white" fontWeight="bold" mt={2}>
                  Estamos evaluando tu solicitud
                </SoftTypography>
                <SoftTypography variant="h6" color="white" fontWeight="bold">
                  En breve recibirás un correo electrónico
                </SoftTypography>
                <SoftTypography variant="caption" color="white" mt={1}>
                  <SoftTypography variant="caption" color="white" fontWeight="regular">
                    Te notificaremos por correo electrónico cuando tu cuenta esté activa para que
                    puedas iniciar sesión y hacer pedidos en el comedor. Recuerda revisar tu
                    bandeja de entrada y la carpeta de spam.
                  </SoftTypography>
                </SoftTypography>
                <SoftBox mt={2}>
                  <SoftButton color="white" circular onClick={handleClose}>
                    <SoftTypography variant="button" color="uproGreen">
                      ACEPTAR
                    </SoftTypography>
                  </SoftButton>
                </SoftBox>
              </SoftBox>
            </Card>
          </Slide>
        </Card>
      </Fade>
    </Modal>
  );
}

ModalBienvenida.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
};
